import React from 'react';
export const FootballAskAI = () => <div>Football Ask AI - Coming Soon</div>;
